// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "patient_document".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { patientDocumentUploadedByValues } from '@borradh-workspace/labels';
/** Response atom for the "patient_document" table (1:1 with a DB row, on the wire). */
export const patientDocumentAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    uploadedByType: z.enum(patientDocumentUploadedByValues),
    uploadedByUserId: z.string().nullable(),
    fileName: z.string(),
    blobUrl: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number(),
    createdAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=patientDocument.js.map